define("mage/bootstrap",["jquery","mage/apply/main","Magento_Ui/js/lib/knockout/bootstrap"],(function(t,a){"use strict";t.ajaxSetup({cache:!1}),setTimeout(a.apply)}));
